import IntlMessages from "../../../../util/IntlMessages";
import React from "react";
import { tDevForm } from "../../RenderDevEditForm";
import "./PositionSection.less";
import "../../RenderDevEditForm.less";

const PositionSection = ({ state, setField, element }: tDevForm) => {
   return (
      <div className="dev-position-section">
         <div className="section-title">
            <IntlMessages id="devForm.fieldPosition" />:
         </div>

         <div className="dev-form-row dev-form-row-gap-24">
            <div className="dev-form-row dev-form-row-gap-8">
               <input
                  type="radio"
                  name={`fieldPosition-${element?.tech_name || "field"}`}
                  value="left"
                  checked={state.position === "left"}
                  onChange={() => setField?.("position", "left")}
               />
               <label>
                  <IntlMessages id="devForm.leftPosition" />
               </label>
            </div>

            <div className="dev-form-row dev-form-row-gap-8">
               <input
                  type="radio"
                  name={`fieldPosition-${element?.tech_name || "field"}`}
                  value="right"
                  checked={state.position === "right"}
                  onChange={() => setField?.("position", "right")}
               />
               <label>
                  <IntlMessages id="devForm.rightPosition" />
               </label>
            </div>

            <div className="dev-form-row dev-form-row-gap-8">
               <input
                  type="radio"
                  name={`fieldPosition-${element?.tech_name || "field"}`}
                  value="page_width"
                  checked={state.position === "page_width"}
                  onChange={() => setField?.("position", "page_width")}
               />
               <label>
                  <IntlMessages id="devForm.fullWidth" />
               </label>
            </div>
         </div>
      </div>
   );
};

export default PositionSection;
